export default __webpack_public_path__ + "static/media/1780.8d415d04.png";